<div class="cabin-detail">
  <div class="main-image" #mainImage>
    <app-carousel
      [showDots]="true"
      [styleDots]="styleDots"
      [autoMoveItems]="false"
      [positionDots]="positionDots"
      [fullHeight]="true">
      <div content class="img-cont"
        *ngFor="let image of [].constructor(quantityImagesFlight); index as id;"
        [id]="id">
        <app-image
          [type]="typeImageFlight"
          [src]="getImageSrc(id)"
          [borderRadius]="borderRadius"
          [dimension]="'x600'">
        </app-image>
      </div>
    </app-carousel>
    <div class="gradient"></div>
    <div class="box-header">
      <div class="title">{{ airplane }}</div>
      <div class="info">{{ airlineName | airlineName }}</div>
    </div>
  </div>
  <div class="body">
    <div class="body--container">
      <div class="box-content--list">
        <app-ds-button-icon
          class="body--action"
          [icon]="icons.Close"
          [buttonSize]="buttonIconSize"
          [iconSize]="16"
          (clickEvent)="close()">
        </app-ds-button-icon>
        <div class="box-content no-background"
          #description
          *ngIf="showDescription">
          <div class="title">
            {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.TITLE_DESCRIPTION' | transloco }}
          </div>
          <div class="content description">
            <p>{{cabin.CabinClass.Description}}</p>
          </div>
        </div>
        <div class="box-content"
          #amenities
          *ngIf="showAmenities">
          <div class="title">
            {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.TITLE_AMENITIES' | transloco }}
          </div>
          <div class="content amenities">
            <div class="amenities-tab">
              <div class="amenities-tab--title"
                *ngIf="cabin.Entertainment.Available"
                [class.active]="isAmenitieTabActive(tabEntertainment)"
                (click)="setAmenitieTab(tabEntertainment)">
                <app-ds-icon
                  [icon]="icons.InFlightEntertainment"
                  [size]="22"
                  [color]="isAmenitieTabActive(tabEntertainment) ? iconFillColor.Neon : iconFillColor.Disabled">
                </app-ds-icon>
                {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.ENTERTAINMENT.TITLE_TAB' | transloco }}
              </div>
              <div class="amenities-tab--title"
                *ngIf="cabin.Power.Available"
                [class.active]="isAmenitieTabActive(tabPower)"
                (click)="setAmenitieTab(tabPower)">
                <app-ds-icon
                  [icon]="icons.Power"
                  [size]="22"
                  [color]="isAmenitieTabActive(tabPower) ? iconFillColor.Neon : iconFillColor.Disabled">
                </app-ds-icon>
                {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.POWER.TITLE_TAB' | transloco }}
              </div>
              <div class="amenities-tab--title"
                *ngIf="cabin.Wifi.Available"
                [class.active]="isAmenitieTabActive(tabWifi)"
                (click)="setAmenitieTab(tabWifi)">
                <app-ds-icon
                  [icon]="icons.Wifi"
                  [size]="22"
                  [color]="isAmenitieTabActive(tabWifi) ? iconFillColor.Neon : iconFillColor.Disabled">
                </app-ds-icon>
                {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.WIFI.TITLE_TAB' | transloco }}
              </div>
            </div>
            <div class="amenitie-item"
              *ngIf="cabin.Entertainment.Available"
              [class.active]="isAmenitieTabActive(tabEntertainment)">
              <div class="amenitie-item--container">
                <div class="amenitie-item--body">
                  <p>{{ cabin.Entertainment.Description}}</p>
                  <p class="amenitie-item--info">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.ENTERTAINMENT.TITLE_TYPES' | transloco }}
                    <strong>{{ getEntertainmentTypes(cabin.Entertainment.Type) }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="amenitie-item"
              *ngIf="cabin.Power.Available"
              [class.active]="isAmenitieTabActive(tabPower)">
              <div class="amenitie-item--container">
                <div class="amenitie-item--body">
                  <p>{{ cabin.Power.Description }}</p>
                  <p class="amenitie-item--info">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.POWER.TITLE_TYPE' | transloco }}
                    <strong>{{ cabin.Power.Type }}</strong>
                  </p>
                  <p class="amenitie-item--info">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.POWER.TITLE_USB' | transloco }}
                    <strong>{{ cabin.Power.USBAvailable }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="amenitie-item"
              *ngIf="cabin.Wifi.Available"
              [class.active]="isAmenitieTabActive(tabWifi)">
              <div class="amenitie-item--container">
                <div class="amenitie-item--body">
                  <p>{{ cabin.Wifi.Description }}</p>
                  <p class="amenitie-item--info"
                    *ngIf="showWithCharge">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.WIFI.TITLE_COST' | transloco }}
                    <strong>{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.WIFI.WITH_CHARGE' | transloco }}</strong>
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="box-content"
          #seats
          *ngIf="showSeats">
          <div class="title">
            {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.TITLE' | transloco }}
            <span class="additional">{{cabin.Seats.Type}}</span>
          </div>
          <div class="content seats">
            <div class="seat-item">
              <div class="seat-item--icon">
                <app-ds-icon
                  [icon]="icons.SeatWidth"
                  [size]="24"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="seat-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.DISTANCE' | transloco }}</div>
              <div class="seat-item--value">{{cabin.Seats.DistanceBetweenSeats}} cm</div>
            </div>
            <div class="seat-item">
              <div class="seat-item--icon">
                <app-ds-icon
                  [icon]="icons.SeatWidth"
                  [size]="24"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="seat-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.WIDTH' | transloco }}</div>
              <div class="seat-item--value">{{cabin.Seats.Width}} cm</div>
            </div>
            <div class="seat-item">
              <div class="seat-item--icon">
                <app-ds-icon
                  [icon]="icons.SeatInclination"
                  [size]="24"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="seat-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.PITCH' | transloco }}</div>
              <div class="seat-item--value">{{cabin.Seats.Pitch}}&deg;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
